import { useId } from 'react';
import { Icono } from '../../componentes/Icono';

/**
 * Lista desplegable con el aspecto de RV Campo (píldora `--rv-paper` de 58 con la etiqueta arriba): un `select` nativo
 * (rueda en iOS), como el selector de contexto del diseño. Para Idioma, País y Comunidad de una sede.
 */
export function Seleccion({ etiqueta, valor, opciones, onChange, ayuda, bloqueado = false }: { etiqueta: string; valor: string; opciones: readonly (readonly [string, string])[]; onChange: (v: string) => void; ayuda?: string; bloqueado?: boolean }) {
    const id = useId();
    return (
        <div className="rv-campo">
            <div className="rv-campo__fila">
                <label htmlFor={id} className={`rv-campo__caja rv-neg-sel${bloqueado ? ' rv-campo__caja--bloqueado' : ''}`}>
                    <span className="rv-campo__etiqueta rv-campo__etiqueta--arriba">{etiqueta}</span>
                    <select
                        id={id}
                        value={valor}
                        disabled={bloqueado}
                        aria-describedby={ayuda === undefined ? undefined : `${id}-ayuda`}
                        onChange={(e) => {
                            onChange(e.target.value);
                        }}
                    >
                        {opciones.map(([v, t]) => (
                            <option key={v} value={v}>
                                {t}
                            </option>
                        ))}
                    </select>
                    <Icono nombre="chevron-down" />
                </label>
            </div>
            {ayuda !== undefined && (
                <span id={`${id}-ayuda`} className="rv-campo__ayuda">
                    {ayuda}
                </span>
            )}
        </div>
    );
}
